import { app } from '../../../app';

class AccessRequestsService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }


    createRequest(requestDTO) {
        const url = `app/rest/accessrequests`;
        return this.$http.post(url, requestDTO).then(({data}) => data);
    }

    getRequests() {
        const url = `app/rest/accessrequests`;
        return this.$http.get(url).then(({data}) => data);
    }

    getCompanies() {
        const url = `app/rest/accessrequests/companies`;
        return this.$http.get(url).then(({data}) => data);
    }

    getApplications(companyId) {
        const url = `app/rest/accessrequests/companies/${companyId}/applications`;
        return this.$http.get(url).then(({data}) => data);
    }

    deleteRequest(requestId) {
        const url = `app/rest/accessrequests/${requestId}`;
        return this.$http.delete(url).then(({data}) => data);   
    }


    getRequestsForCompany(companyId) {
        const url = `app/rest/company/${companyId}/accessrequest`;
        return this.$http.get(url).then(({data}) => data);
    }

    deleteRequestForCompany(companyId, requestId) {
        const url = `app/rest/company/${companyId}/accessrequest/${requestId}`;
        return this.$http.delete(url).then(({data}) => data);         
    }

    approveRequest(companyId, requestId, accountId) {
        const url = `app/rest/company/${companyId}/accessrequest/${requestId}/approve/${accountId}`;
        return this.$http.post(url).then(({data}) => data);
    }
}

app.service('AccessRequestsService', AccessRequestsService);



// WEBPACK FOOTER //
// ./src/portal/states/user/access-requests/access-requests.service.js